import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Grid,
  Box,
  Tooltip,
  Container,
  Paper,
  Link as MuiLink,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { useSelector, useDispatch } from "react-redux";
import { loginSelector, selectUser } from "../../redux/selectors/user.selector";
import { setRedirectToPricingPage } from "../../redux/reducers/ui";
import axios from "axios";
import Loader from "../common/loader";

const Pricing = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedin = useSelector(loginSelector);
  const userData = useSelector(selectUser);
  const [isLoading, setIsLoading] = useState(false);
  const redirectToPricing = useSelector((state) => state.ui.redirectToPricing);

  const handleSubscribe = async () => {
    setIsLoading(true);
    if (isLoggedin) {
      let email = userData.email;
      let phone = userData.phoneNumber;
      await axios
        .get(
          `${process.env.REACT_APP_API_ENDPOINT}/subscription/create?email=${email}&phone_number=${phone}`
        )
        .then((response) => {
          window.location.href = response.data;
        })
        .catch((err) => console.log(err));
    } else {
      dispatch(setRedirectToPricingPage(true));
      navigate("/login");
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  useEffect(() => {
    if (redirectToPricing) {
      handleSubscribe();
      dispatch(setRedirectToPricingPage(false));
    }
  }, [redirectToPricing]);

  return (
    <Box sx={{ padding: "100px 0 0 0" }}>
      {isLoading && <Loader />}

      <Typography variant="h4" align="center" gutterBottom>
        Choose Your Plan
      </Typography>

      <Container maxWidth="md" style={{ marginTop: "50px" }}>
        <Grid container spacing={3}>
          {/* Free Trial Tile */}
          <Grid item xs={12} sm={6}>
            <Paper
              elevation={3}
              style={{
                padding: "20px",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
              }}
            >
              <Typography variant="h5" gutterBottom>
                Free Trial
              </Typography>
              <Typography variant="h3" gutterBottom>
                $0
              </Typography>
              <Typography variant="body1">
                Try our WhatsApp Copilot integration with Autodesk Construction
                Cloud for one month free.
              </Typography>

              <Tooltip
                title={
                  ((userData && userData.subscriptionActivated) ||
                    (userData && userData.trialActivated === true)) &&
                  "You already took our free trial"
                }
              >
                <span>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    style={{
                      color: `black`,
                      borderColor: `black`,
                    }}
                    sx={{ marginTop: "20px" }}
                    onClick={() => navigate("/sign-up")}
                    disabled={
                      (userData && userData.subscriptionActivated) ||
                      (userData && userData.trialActivated === true)
                    }
                  >
                    Start free trial
                  </Button>
                </span>
              </Tooltip>
            </Paper>
          </Grid>

          {/* $5 Subscription Tile */}
          <Grid item xs={12} sm={6}>
            <Paper
              elevation={3}
              style={{
                padding: "20px",
              }}
            >
              <Typography variant="h5" gutterBottom>
                Basic
              </Typography>
              <Typography variant="h3" gutterBottom>
                $5
              </Typography>
              <Typography variant="body1">
                Enjoy full access to our Autodesk Construction Cloud Copilot for
                WhatsApp .
              </Typography>

              <Tooltip
                title={
                  userData &&
                  userData.subscriptionActivated &&
                  "You already have an active subscription"
                }
              >
                <span>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    style={{}}
                    sx={{ marginTop: "20px" }}
                    onClick={handleSubscribe}
                    title={
                      userData &&
                      userData.subscriptionActivated &&
                      "You already have an active subscription"
                    }
                  >
                    Subscribe
                  </Button>
                </span>
              </Tooltip>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <Typography variant="body1" align="center" sx={{ marginTop: "20px" }}>
        Have questions?{" "}
        <MuiLink
          component={Link}
          to="/contact-us"
          color="primary"
          underline="hover"
          fontWeight={500}
        >
          Contact Us
        </MuiLink>
      </Typography>

      <Typography variant="body1" align="center" sx={{ marginTop: "20px" }}>
        Refund requests? Check out our{" "}
        <MuiLink
          component={Link}
          to="/refunds"
          color="primary"
          underline="hover"
          fontWeight={500}
        >
          Refund Policy
        </MuiLink>
        .
      </Typography>
    </Box>
  );
};

export default Pricing;
